import { styled } from '@grupoboticario/flora-react';
import { Header } from 'ui/components/templates/Header';

export const HeaderCheckout = {
  Header: styled(Header, {
    '&[data-header-checkout="true"]': {
      height: 'calc($22 + $14)',

      '@mobile': {
        height: '$22',
        minHeight: '$22 !important',
      },
    },
  }),

  Component: styled('div', {
    alignItems: 'center',
    display: 'grid',
    gap: '$4',
    gridTemplate: 'auto auto / repeat(3, auto)',
    justifyContent: 'space-between',
    padding: '0 0 $6 0',
    width: '100%',

    '@tablet': {
      padding: 0,
    },
  }),
};
